module.exports = __webpack_public_path__ + "img/vector-bg-13.aceca9d5.svg";